import { useEffect, useRef, useState } from 'react'

import type { ReducedConjuredArticleElement } from '.'
import kebabCase from 'lodash/kebabCase'

export function TableOfContentsHook({
  elements,
}: {
  elements: ReducedConjuredArticleElement[]
}) {
  const [activeId, setActiveId] = useState('')
  const observer = useRef<IntersectionObserver | null>(null)

  useEffect(() => {
    const handleObsever = (entries: IntersectionObserverEntry[]) => {
      entries.forEach((entry: IntersectionObserverEntry) => {
        if (entry.isIntersecting) {
          setActiveId(entry.target.id)
        }
      })
    }

    observer.current = new IntersectionObserver(handleObsever, {
      rootMargin: '-20% 0% -35% 0px',
    })
    // what about the clidren of a specific element?
    const observedElements = elements.map((element) => {
      const elem = document.getElementById(kebabCase(element.heading))
      return elem
    })

    observedElements.forEach((elem) => {
      if (observer.current && elem) {
        observer.current.observe(elem)
      }
    })

    return () => observer.current?.disconnect()
  }, [])

  return { activeId }
}
